import { useState, useCallback } from 'react';
import { sendContactMessage } from '../../../api/contact';
import '../../../styles/select.css';

const ContactArea = () => {
   const [formData, setFormData] = useState({
      name: '',
      email: '',
      phone: '',
      inquiryType: '',
      message_text: ''
   });
   const [isLoading, setIsLoading] = useState(false);
   const [status, setStatus] = useState({ type: '', message: '' });

   const handleChange = useCallback((e) => {
      const { name, value } = e.target;
      setFormData(prev => ({
         ...prev,
         [name]: value
      }));
   }, []);

   const handleSubmit = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      setStatus({ type: '', message: '' });

      try {
         const response = await sendContactMessage(formData);
         console.log('response: ', response);
         setStatus({
            type: 'success',
            message: response.message
         });
         // Reset form
         setFormData({
            name: '',
            email: '',
            phone: '',
            inquiryType: '',
            message_text: ''
         });
      } catch (error) {
         setStatus({
            type: 'error',
            message: error.message
         });
      } finally {
         setIsLoading(false);
      }
   };

   return (
      <section className="contact__area">
         <div className="container-fluid p-0">
            <div className="row g-0"></div>
            <div className="col-xl-12">
               <div className="contact__map">
                  <div className="contact__wrapper d-md-flex justify-content-between wow fadeInUp" data-wow-delay=".3s">
                     <div className="contact__info mr-100">
                        <h3>Get in touch</h3>
                        <ul>
                           <li>
                              <h4>Location</h4>
                              <p>7460 Warren Parkway Suite-100<br />Frisco TX 75034</p>
                           </li>
                           <li>
                              <h4>Call Us</h4>
                              <p><a href="tel:+14696761128">469-676-1128</a></p>
                              <p><a href="tel:+18773007146">+1 (877) 300-7146</a> <span style={{ fontSize: "12px", color: "#666" }}>(Spectrum Business)</span></p>
                           </li>
                           <li>
                              <h4>Email Address</h4>
                              <p><a href="mailto:contact@vectortechsol.com">contact@vectortechsol.com</a></p>
                              {/* <p><a href="mailto:contact@vectortechsol.com">contact@vectortechsol.com</a></p> */}
                           </li>
                        </ul>
                     </div>
                     <div className="contact__form">
                        <form onSubmit={handleSubmit}>
                           <input
                              type="text"
                              name="name"
                              required
                              placeholder="Your Name"
                              value={formData.name}
                              onChange={handleChange}
                           />
                           <input
                              type="email"
                              name="email"
                              required
                              placeholder="Your Email"
                              value={formData.email}
                              onChange={handleChange}
                           />
                           <input
                              type="tel"
                              name="phone"
                              placeholder="Your Phone"
                              value={formData.phone}
                              onChange={handleChange}
                           />
                           <select
                              required
                              name="inquiryType"
                              className="custom-select"
                              value={formData.inquiryType}
                              onChange={handleChange}
                           >
                              <option value="" disabled>Inquiry about</option>
                              <option value="General Inquiry">General Inquiry</option>
                              <option value="Employment verification">Employment verification</option>
                           </select>
                           <textarea
                              required
                              name="message_text"
                              placeholder="Your Message"
                              value={formData.message_text}
                              onChange={handleChange}
                           ></textarea>

                           {status.message && (
                              <div className={`alert alert-${status.type === 'success' ? 'success' : 'danger'} mt-3`}>
                                 {status.message}
                              </div>
                           )}

                           <button
                              type="submit"
                              className="z-btn"
                              disabled={isLoading}
                           >
                              {isLoading ? 'Sending...' : 'Send Message'}
                           </button>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
};

export default ContactArea;